import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { RankingFilterState } from '../states/rankingFilter.atom';
import {
  GOODS_RANKING_SCREEN,
  getCommonFilterAnalytics,
} from './getCommonFilterAnalytics';

type FilterType = 'CATEGORY' | 'AGE' | 'PERIOD';

export const useLogApplyFilter = () => {
  return useCallback(
    (nextFilter: RankingFilterState, filterType: FilterType) => {
      bridge.logAnalyticsEvent({
        name: 'APPLY_FILTER',
        analytics: {
          SCREEN: GOODS_RANKING_SCREEN,
          ...getCommonFilterAnalytics(nextFilter),
          FILTER_TYPE: filterType,
        },
      });
    },
    [],
  );
};
